import {
  Users2, Luggage, ShieldAlert, Siren, BookMarked, KeyRound, Camera, Hammer, Landmark, Zap, CreditCard, MapPinned, Images, Gauge, HandCoins,
  House, Wallet, Receipt, PieChart, Smile, ListChecks, PiggyBank, Gift, CalendarDays, Plane, Link2,
  UtensilsCrossed, HeartPulse, BookOpen, Moon, Timer, GraduationCap, MessagesSquare, MessageCircle, Video, Clapperboard, PlayCircle, Users, Settings, ShieldCheck, Building2, UserRound, ScrollText, LayoutDashboard, Palette, Target, ShoppingBasket, ListTodo, Sparkles, Wrench, LockKeyhole, Boxes, Umbrella, Car, PawPrint, Stethoscope, Backpack, Cake, HeartHandshake, Repeat, ScanLine, Printer, FolderOpen, Library as LibraryIcon, CalendarClock, FileHeart, FileText,
} from "lucide-react";

export const NAV_GROUPS = [
  { label: "Home", Icon: House, glowRgb: "var(--glow-home)", section: null,
    items: [{ id: "home", label: "Home", path: "home", Icon: House },
      { id: "home-care", label: "Home care", path: "home-care", Icon: Wrench, section: "home", countKey: "home_care", description: "Overdue home care tasks" },
      { id: "inventory", label: "Inventory", path: "home/inventory", Icon: Boxes, section: "inventory" },
      { id: "insurance", label: "Insurance", path: "home/insurance", Icon: Umbrella, section: "insurance" },
      { id: "projects", label: "Projects", path: "projects", Icon: Hammer, section: "home" },
      { id: "library", label: "Learn", path: "library", Icon: LibraryIcon, section: "family" },
      { id: "vehicles", label: "Vehicles", path: "home/vehicles", Icon: Car, section: "vehicles" },
      { id: "roommates", label: "Shared bills", path: "roommates", Icon: Users2, section: "roommates" },
      { id: "shutoffs", label: "Shutoffs", path: "shutoffs", Icon: ShieldAlert, section: "shutoffs" },
      { id: "prep", label: "Emergency prep", path: "prep", Icon: Siren, section: "prep" },
      { id: "manual", label: "Household manual", path: "manual", Icon: BookMarked, section: "manual" },
      { id: "away", label: "Away checklist", path: "away", Icon: Luggage, section: "away" },
      { id: "lease", label: "Lease & rent", path: "lease", Icon: KeyRound, section: "lease" },
      { id: "movelog", label: "Move-in/out log", path: "movelog", Icon: Camera, section: "movelog" },
      { id: "maintenance", label: "Maintenance", path: "maintenance", Icon: Hammer, section: "maintenance" },
      { id: "housing", label: "Housing costs", path: "housing", Icon: Landmark, section: "housing" },
      { id: "utilities", label: "Utilities", path: "utilities", Icon: Zap, section: "utilities" },
      { id: "pets", label: "Pets", path: "pets", Icon: PawPrint, section: "pets" },
      { id: "memories", label: "Memories", path: "memories", Icon: Images, section: "memories" }] },
  { label: "Money", Icon: Wallet, glowRgb: "var(--glow-money)", section: "money",
    items: [
      { id: "bills", label: "Bills", path: "money/bills", Icon: Receipt, countKey: "bills", description: "Overdue bills shown in the pill" },
      { id: "spending", label: "Spending", path: "money/spending", Icon: PieChart },
      { id: "savings-goals", label: "Savings Goals", path: "money/savings-goals", Icon: Target },
      { id: "budgets", label: "Budgets", path: "money/budgets", Icon: Gauge },
      { id: "splits", label: "Splits", path: "money/splits", Icon: HandCoins, section: "splits" },
      { id: "tax", label: "Tax folder", path: "money/tax", Icon: FolderOpen, section: "tax" },
      { id: "irregular", label: "Irregular expenses", path: "money/irregular", Icon: CalendarClock, section: "tax" },
    ] },
  { label: "Kids Corner", slug: "kids", Icon: Smile, glowRgb: "var(--glow-kids)", section: "kids",
    items: [
      { id: "chores", label: "Chores", path: "kids/chores", Icon: ListChecks, countKey: "chores", description: "Waiting approvals (parents) or chores left today (kids)" },
      { id: "piggy-bank", label: "Piggy Bank", path: "kids/piggy-bank", Icon: PiggyBank },
      { id: "wish-list", label: "Wish List", path: "kids/wish-list", Icon: Gift },
      { id: "learn-play", label: "Learn & Play", path: "kids/learn", Icon: GraduationCap },
      { id: "screen-time", label: "Screen Time", path: "kids/screen-time", Icon: Timer },
      { id: "story-time", label: "Story Time", path: "kids/story-time", Icon: BookOpen },
      { id: "bedtime", label: "Bedtime", path: "kids/bedtime", Icon: Moon },
    ] },
  { label: "Copilot", Icon: Sparkles, glowRgb: "var(--glow-copilot)", solo: true,
    items: [{ id: "copilot", label: "Copilot", path: "copilot", Icon: Sparkles }] },
  { label: "Lists", Icon: ShoppingBasket, glowRgb: "var(--glow-lists)", section: "lists",
    items: [
      { id: "lists", label: "Lists", path: "lists", Icon: ListTodo, section: "lists" },
      { id: "meals", label: "Meals", path: "meals", Icon: UtensilsCrossed, section: "meals" },
    ] },
  { label: "Calendar", Icon: CalendarDays, glowRgb: "var(--glow-calendar)", section: "calendar",
    items: [
      { id: "family-calendar", label: "Family Calendar", path: "calendar/family", Icon: CalendarDays },
      { id: "flights", label: "Flights & Trips", path: "calendar/flights", Icon: Plane },
      { id: "calendar-links", label: "Calendar Links", path: "calendar/links", Icon: Link2 },
    ] },
  { label: "Connect", Icon: MessagesSquare, glowRgb: "var(--glow-connect)", section: "connect",
    items: [
      { id: "messages", label: "Messages", path: "connect/messages", Icon: MessageCircle, countKey: "messages", description: "Unread messages shown in the pill" },
      { id: "video-calls", label: "Video Calls", path: "connect/video", Icon: Video },
      { id: "whos-where", label: "Who's where", path: "connect/whos-where", Icon: MapPinned, section: "checkins", description: "Tap-to-check-in board (no GPS)" },
    ] },
  { label: "Media", Icon: Clapperboard, glowRgb: "var(--glow-media)", section: "media",
    items: [{ id: "shortcuts", label: "Shortcuts", path: "media/shortcuts", Icon: PlayCircle }] },
  { label: "Family", Icon: Users, glowRgb: "var(--glow-family)", section: "family",
    items: [
      { id: "members", label: "Members", path: "family/members", Icon: Users },
      { id: "settings", label: "Settings", path: "family/settings", Icon: Settings },
      { id: "health", label: "Health", path: "family/health", Icon: Stethoscope, section: "health" },
      { id: "school", label: "School & Activities", path: "school", Icon: Backpack, section: "school" },
      { id: "birthdays", label: "Birthdays & Gifts", path: "birthdays", Icon: Cake, section: "birthdays" },
      { id: "coparent", label: "Co-parenting", path: "coparent", Icon: HeartHandshake, section: "coparent" },
      { id: "subscriptions", label: "Subscriptions", path: "subscriptions", Icon: Repeat, section: "subscriptions" },
      { id: "scanning", label: "Scanning", path: "scanning", Icon: ScanLine, section: "scanning" },
      { id: "printables", label: "Printables", path: "printables", Icon: Printer, section: "family" },
      { id: "emergency", label: "Emergency info", path: "family/emergency", Icon: HeartPulse, section: "emergency" },
      { id: "vault", label: "Documents", path: "family/documents", Icon: LockKeyhole, section: "vault" },
      { id: "ish", label: "If something happens", path: "family/if-something-happens", Icon: FileHeart, section: "ish" },
      { id: "billing", label: "Billing", path: "family/billing", Icon: CreditCard, ownerOnly: true },
      { id: "gift", label: "Gift a year", path: "account/gift", Icon: Gift, giftOnly: true },
      { id: "my-look", label: "My Look", path: "family/my-look", Icon: Palette, everyone: true },
    ] },
];

export const ADMIN_FAMILY_GROUP = {
  label: "Family", Icon: Users, glowRgb: "var(--glow-family)", section: "family",
  items: [{ id: "my-look", label: "My Look", path: "admin/my-look", Icon: Palette, adminOnly: true }],
};

export const ADMIN_GROUP = {
  label: "Admin", Icon: ShieldCheck, glowRgb: "var(--glow-admin)", section: "admin",
  items: [
    { id: "admin-home", label: "Console home", path: "admin/home", Icon: LayoutDashboard, adminOnly: true },
    { id: "admin-families", label: "Families", path: "admin/families", Icon: Building2, adminOnly: true },
    { id: "admin-users", label: "Users", path: "admin/users", Icon: UserRound, adminOnly: true },
    { id: "admin-admins", label: "Admins", path: "admin/admins", Icon: ShieldCheck, adminOnly: true },
    { id: "admin-audit", label: "Audit log", path: "admin/audit-log", Icon: ScrollText, adminOnly: true },
    { id: "admin-explainers", label: "Explainers", path: "admin/explainers", Icon: BookOpen, adminOnly: true },
    { id: "admin-plans", label: "Plans", path: "admin/plans", Icon: CreditCard, adminOnly: true },
    { id: "admin-partner-brief", label: "Partner brief (PDF)", path: "admin/partner-brief", Icon: FileText, adminOnly: true, superOnly: true },
    { id: "admin-patent-packet", label: "Patent packet (PDF)", path: "admin/patent-packet", Icon: FileText, adminOnly: true, superOnly: true },
    { id: "admin-competitor-brief", label: "Competitor brief (PDF)", path: "admin/briefs/competitor", Icon: FileText, adminOnly: true, superOnly: true },
    { id: "admin-combined-brief", label: "Combined competitor brief", path: "admin/briefs/combined", Icon: FileText, adminOnly: true, superOnly: true },
    { id: "admin-sidebar-guide", label: "Sidebar code guide", path: "admin/briefs/sidebar-guide", Icon: FileText, adminOnly: true, superOnly: true },
  ],
};

export const SOON_COPY = {
  chores: "Chores with rewards, assigned to each kid and approved by a parent.",
  "piggy-bank": "A digital piggy bank that fills up when chores are approved.",
  "wish-list": "Kids' Amazon wish lists with an \"I want this\" button.",
  "family-calendar": "One family calendar for school, athletics, flights and vacations.",
  flights: "Add a flight number and watch live status on the calendar.",
  "calendar-links": "Subscribe to school, sports and outside calendars.",
  messages: "Family group chat, direct messages and custom groups.",
  "video-calls": "One-to-one and group video calls inside the hub.",
  shortcuts: "Shortcuts to your favourite video and music apps, chosen per kid.",
};

export function findItem(path) {
  for (const g of NAV_GROUPS) {
    const item = g.items.find((i) => i.path === path);
    if (item) return { group: g, item };
  }
  return null;
}

export function canSee(section, hub) {
  if (!section) return true;
  if (section === "roommates") return hub.type === "roommates";
  if (section === "tax") return !(hub.sections_off || []).includes("money") && (!hub.view_mode || hub.view_mode === "member") && (hub.type === "roommates" || ["owner", "coparent"].includes(hub.my_role));
  if (section === "ish") return hub.my_role !== "kid" && (!hub.view_mode || hub.view_mode === "member");
  if (section === "family") return hub.my_role !== "kid";
  if ((section === "emergency" || section === "health") && hub.view_mode && hub.view_mode !== "member") return false;
  if (section === "vault") return !!hub.vault_access;
  if (section === "splits") return hub.my_role !== "kid" && !(hub.sections_off || []).includes("money");
  if (section === "home" && hub.my_role === "kid") return false;
  return !!hub.my_access?.[section];
}
